/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object,
} from 'prop-types';
import { Container } from '@material-ui/core';
import HeaderPart from './partials/HeaderPart';
import ProductDetails from './partials/ProductDetails';
import ProductDescription from './partials/ProductDescription';
import PlantsCareDetails from './partials/PlantsCareDetails';

const ProductDetailsPage = (props) => {
    const { data } = props;
    const {
        product: {
            longDescription,
        },
    } = data;
    return (
        <Container>
            <HeaderPart />
            <ProductDetails pageData={data} />
            {longDescription && <ProductDescription description={longDescription} /> }
            <PlantsCareDetails pageData={data} />
        </Container>
    );
};

ProductDetailsPage.propTypes = {
    data: object.isRequired,
};

export default ProductDetailsPage;
